// @flow
import { Button, Grid, TextField } from "@material-ui/core";
import { isEmpty } from "lodash-es";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import Modal from "../../../../../components/modals/modal.mesf";
import { setPassword } from "../../repositories/UsersRepository";

type Props = {
	show: boolean;
	userId: number | null;
	onHide: (shouldUpdate: boolean) => void;
};
export const ChangePassword = ({ show, userId, onHide }: Props) => {
	const [password, setPasswordText] = useState("");
	const [isDirty, setIsDirty] = useState(false);

	const handleSubmit = useCallback(
		async (ev) => {
			ev.preventDefault();
			const resp = await setPassword(userId!, password);
			onHide(true);
		},
		[userId, password],
	);

	useEffect(() => {
		if (show) {
			setPasswordText("");
			setIsDirty(false);
		}
	}, [show]);

	if (userId) {
		return (
			<>
				<Modal
					title={`Change password`}
					open={show}
					handleClose={() => onHide(false)}
					maxWidth="lg"
				>
					<Grid container>
						<Grid item md={12} xs={12}>
							<Modal.Content style={{ padding: "6px 16px 16px" }}>
								<form onSubmit={handleSubmit}>
									<Grid item md={12} xs={12}>
										<TextField
											label="New Password"
											value={password}
											onChange={(el) => {
												setIsDirty(true);
												setPasswordText(el.target.value);
											}}
											variant="outlined"
											error={isEmpty(password) && isDirty}
											fullWidth
											// margin="dense"
											autoComplete="off"
										/>
									</Grid>

									<Grid item md={12} xs={12} style={{ marginTop: 15 }}>
										<Button
											fullWidth
											variant="contained"
											color="primary"
											type={"submit"}
										>
											APPLY
										</Button>
									</Grid>
								</form>
							</Modal.Content>
						</Grid>
					</Grid>
				</Modal>
			</>
		);
	} else {
		return <></>;
	}
};
